import { Placement } from "react-joyride";

export const GUIDE_STEPS: {
	target: string;
	content: string;
	disableBeacon?: boolean;
	placement?: Placement | "center";
	continuous?: boolean;
	locale?: {
		close: string;
	};
}[] = [
	{
		target: ".guide_welcome",
		content:
			"Welcome! 🎉 Let’s take a quick tour so you can create your digital invitation with ease. It only takes a minute!",
		placement: "center",
		disableBeacon: true,
		continuous: true,
		locale: { close: "Start Tour" }
	},
	{
		target: ".guide_edit_field",
		content:
			"Click any field in your invitation to start editing it. Try selecting the groom’s name to see how it works.",
		disableBeacon: true,
		locale: { close: "Next" }
	},
	{
		target: ".guide_field_update",
		content:
			"✏️ Great! Now update the groom’s name from the editor panel. Just type the new name and save — the invitation updates instantly.",
		disableBeacon: true,
		locale: { close: "Next" }
	},
	{
		target: ".guide_settings_btn",
		content: "Open your invitation settings here to adjust details, preferences, and layout options.",
		disableBeacon: true,
		locale: { close: "Next" }
	},
	{
		target: ".progress_settings_btn",
		content:
			"Make sure to complete the required fields — groom’s name, bride’s name, wedding date, and location — to enable publishing.",
		disableBeacon: true,
		locale: { close: "Next" }
	},
	{
		target: ".guide_publish_btn",
		content: "Ready to go live? Click here to request publishing for your invitation.",
		disableBeacon: true,
		locale: { close: "Next" }
	},
	{
		target: ".guide_share_btn",
		content: "Once published, share your invitation with guests directly from here.",
		disableBeacon: true,
		locale: { close: "Next" }
	},
	{
		target: ".guide_dashboard_btn",
		content: "Track RSVP responses and guest activity in your dashboard — all in one place.",
		disableBeacon: true,
		locale: { close: "Finish" }
	}
];
